
import swal from 'sweetalert2'

const Toast = swal.mixin({
	toast: true,
	position: 'top-end',
	showConfirmButton: false,
	grow: 'column',
	timer: 8000
})

let toasty = (msg, title, type) => {
    Toast.fire({
		type: (type) ? type :'info',
		title: (title) ? title : '&nbsp',
		text: msg
	})
}

export {
    toasty
}